import { createAPI } from '@common'
export default {
  // 根据docLibID获取其根文件夹ID
  getRootIdByDocLibID: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0gpmefst0sppu', 'GET', config),
  // 获取树,权限
  getFoldersAdmin: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0dpowfshfe0usff0benjo', 'GET', config),
  // 需要调用获取根文件夹ID获取文件夹节点
  getFoldersTree: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0dpowfshfe0usff', 'GET', config),
  // 列表查询
  postConvergedList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0dpowfshfe0mjtu', 'POST', config),
  // 操作
  getActions: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0f60bdujpot', 'GET', config),
  // 选用热文
  getHotSelect: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0dpowfshfe0ipu0tfmfdu', 'GET', config),
  // 每日热文
  getHotDaily: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0dpowfshfe0ipu0ebjmz', 'GET', config),
  // 详情
  getDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0dpowfshfe0efubjm', 'GET', config),
  // 移除
  postDelete: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0dpowfshfe0efmfuf', 'POST', config),
  // 撤稿
  postRevoke: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0dpowfshfe0sfwplf', 'POST', config),
  // 选用
  postSelect: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0dpowfshfe0tfmfdu', 'POST', config),
    // 已选用列表
  getSelectList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0dpowfshfe0tfmfdu0mjtu', 'GET', config),
    // 移动
  postMove: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0dpowfshfe0npwf', 'POST', config),
    // 移动的预处理
  getMovePrecheck: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0dpowfshfe0npwf0qsfdifdl', 'GET', config),
    // 转指令的预处理
  getCommandPrecheck: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0dpowfshfe0dpowfsu3Dpnnboe0qsfdifdl', 'GET', config),
}
